export default __webpack_public_path__ + "static/media/Frame.b6b1b5e1.svg";